// src/socket.js
import { io } from "socket.io-client";
const socket = io(process.env.REACT_APP_API_BASE); // e.g. http://localhost:5000
export default socket;
